/**
 * Fleet-wide blocklist pushes on `dw/fleet/blocklist` (design-addendum §2). The
 * manifests service publishes `{"blocklist": ["crv_...", ...]}`; the native shell
 * forwards MQTT payloads over the JS bridge (dwf-030 transport, dwf-032 shell).
 */

export function parseFleetBlocklistPayload(payload: unknown): readonly string[] | null {
  if (typeof payload === 'string') {
    try {
      return parseFleetBlocklistPayload(JSON.parse(payload) as unknown);
    } catch {
      return null;
    }
  }
  if (typeof payload !== 'object' || payload === null) return null;
  const blocklist = (payload as Record<string, unknown>)['blocklist'];
  if (!Array.isArray(blocklist) || blocklist.some((entry) => typeof entry !== 'string')) {
    return null;
  }
  return blocklist as string[];
}
